"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6035],{

/***/ 66035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer1_Footer1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer1/Footer1.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  &.bg_type_image {\n    background: ",
        ";\n  }\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  /* &.bg_type_image::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  } */\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 2.5rem 4rem;\n  display: flex;\n  position: relative;\n  z-index: 10;\n  & .left-container {\n    flex: 0.6;\n    display: flex;\n  }\n  & .middle-container {\n    flex: 1;\n    align-items: center;\n  }\n  & .middle-container,\n  .right-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n  }\n  & .middle-container .privacy-terms-container {\n    display: flex;\n    gap: 1.5rem;\n    font-size: 0.875rem;\n    text-align: center;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  & .middle-container .privacy-terms-container .privacy-policy,\n  .middle-container .privacy-terms-container .terms-conditions {\n    display: flex;\n    flex-wrap: wrap;\n    cursor: pointer;\n  }\n  & .middle-container .addressContainer {\n    text-align: center;\n    font-size: 0.813rem;\n    font-weight: 500;\n    line-height: 22px;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    display: flex;\n    flex-wrap: wrap;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .middle-container .addressContainer .address {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .middle-container .addressContainer .address .contact {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .right-container {\n    align-items: flex-end;\n    flex: 0.6;\n  }\n\n  & .right-container .footer-rights-container {\n    text-align: right;\n    display: flex;\n    flex-direction: column;\n    gap: 0.563rem;\n    opacity: 0.6;\n  }\n  & .right-container .social-media-section {\n    display: flex;\n    justify-content: space-between;\n  }\n  & .right-container .footer-rights-container .copyright,\n  & .right-container .footer-rights-container .copyright-sub-text {\n    font-style: normal;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  & .right-container .footer-rights-container .copyright {\n    font-size: 0.75rem;\n  }\n  & .right-container .footer-rights-container .copyright-sub-text {\n    font-size: 0.625rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 2.5rem 1rem;\n  flex-direction: column;\n  gap: 2.5rem;\n  position: relative;\n  z-index: 10;\n  & > .first-container {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  & .first-container .privacy-terms-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    font-size: 0.875rem;\n    text-align: center;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .second-container .social-media-section {\n    display: flex;\n    justify-content: center;\n  }\n  & .third-container .addressContainer {\n    display: flex;\n    flex-wrap: wrap;\n    text-align: center;\n    font-size: 0.813rem;\n    line-height: 22px;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .third-container .addressContainer .address {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & .third-container .addressContainer .address .contact {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .fourth-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  & > .fifth-container .footer-rights-container .copyright,\n  & > .fifth-container .footer-rights-container .copyright-sub-text {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    font-style: normal;\n    opacity: 0.6;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .fifth-container .footer-rights-container .copyright {\n    font-size: 0.75rem;\n  }\n  & > .fifth-container .footer-rights-container .copyright-sub-text {\n    font-size: 0.625rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterContainer",
    componentId: "sc-ef4ceca0-0"
})(_templateObject(), function(props) {
    var ref, ref1, ref2, ref3, ref4;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat((props === null || props === void 0 ? void 0 : (ref4 = props.propsBackground) === null || ref4 === void 0 ? void 0 : ref4.default) || (props === null || props === void 0 ? void 0 : props.themeBackground));
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* FOOTER_OPACITY */.he, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var FooterDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterDesktopContainer",
    componentId: "sc-ef4ceca0-1"
})(_templateObject1(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
});
var FooterMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterMobileContainer",
    componentId: "sc-ef4ceca0-2"
})(_templateObject2(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/Footer/utils/commonGetterFunction.js
var commonGetterFunction = __webpack_require__(605790);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer1/Components/FooterDesktop.js



var FooterDesktop = function(props) {
    var footerState = props.footerState, store = props.store, propStyle = props.propStyle, handleLogoClick = props.handleLogoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopContainer, {
        themeBackground: propStyle,
        className: "footerDesktopContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left-container",
                children: (0,commonGetterFunction/* getStoreLogo */.B9)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements, handleLogoClick)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "middle-container",
                children: [
                    (0,commonGetterFunction/* getSpecificPageVisibleItems */.Ds)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements),
                    (0,commonGetterFunction/* getAddressDetails */.IL)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-container",
                children: [
                    (0,commonGetterFunction/* getActiveSocialMedia */.dw)(store),
                    (0,commonGetterFunction/* getFooterRightReservedtext */.E2)()
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_FooterDesktop = (FooterDesktop);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer1/Components/FooterMobile.js



var FooterMobile = function(props) {
    var footerState = props.footerState, store = props.store, propStyle = props.propStyle, handleLogoClick = props.handleLogoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileContainer, {
        propStyle: propStyle,
        className: "footerMobileContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "first-container",
                children: (0,commonGetterFunction/* getSpecificPageVisibleItems */.Ds)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "second-container",
                children: (0,commonGetterFunction/* getActiveSocialMedia */.dw)(store)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "third-container",
                children: (0,commonGetterFunction/* getAddressDetails */.IL)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fourth-container",
                children: (0,commonGetterFunction/* getStoreLogo */.B9)(footerState === null || footerState === void 0 ? void 0 : footerState.footerElements, handleLogoClick)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fifth-container",
                children: (0,commonGetterFunction/* getFooterRightReservedtext */.E2)()
            })
        ]
    });
};
/* harmony default export */ var Components_FooterMobile = (FooterMobile);

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer1/Footer1.js











var Footer1 = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)((props === null || props === void 0 ? void 0 : props.isAlreadyTransformed) ? props === null || props === void 0 ? void 0 : props.footerState : (0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), footerState = ref4[0], setFooterState = ref4[1];
    var ref5 = (0,react.useState)(true), IS_DESKTOP = ref5[0], setIS_DESKTOP = ref5[1];
    var checkWindowSize = function() {
        if (true) {
            var isMobile = window.innerWidth < 768; // You can adjust this threshold
            setIS_DESKTOP(!isMobile);
        }
    };
    (0,react.useEffect)(function() {
        // Check window size on component mount
        checkWindowSize();
        // Add event listener for window resize only on the client side
        var handleResize = function() {
            checkWindowSize();
        };
        if (true) {
            window.addEventListener("resize", handleResize);
            // Cleanup the event listener on component unmount
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        setFooterState((props === null || props === void 0 ? void 0 : props.isAlreadyTransformed) ? props === null || props === void 0 ? void 0 : props.footerState : (0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        props
    ]);
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref6 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref6[0], setPropStyle = ref6[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template
    ]);
    var router = (0,next_router.useRouter)();
    var handleLogoClick = function() {
        var ref;
        return router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    //   const [isDesktop, setIsDesktop] = useState(window.innerWidth>768);
    //   useEffect(() => {
    //     const handleResize = () => {
    //       setIsDesktop(window.innerWidth > 768);
    //     };
    //     window.addEventListener('resize', handleResize);
    //     return () => {
    //       window.removeEventListener('resize', handleResize);
    //     };
    //   }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        id: "Footer1",
        propsBackground: footerState === null || footerState === void 0 ? void 0 : (ref3 = footerState.media) === null || ref3 === void 0 ? void 0 : ref3.background,
        themeBackground: propStyle,
        className: "modern_theme_footer1 bg_type_solid",
        children: IS_DESKTOP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_FooterDesktop, {
            store: storeData,
            footerState: footerState,
            setFooterState: setFooterState,
            propStyle: propStyle,
            handleLogoClick: handleLogoClick
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_FooterMobile, {
            store: storeData,
            footerState: footerState,
            setFooterState: setFooterState,
            propStyle: propStyle,
            handleLogoClick: handleLogoClick
        })
    });
};
/* harmony default export */ var Footer1_Footer1 = (Footer1);


/***/ })

}]);